import { PageContent, Box, Header, Heading, Paragraph, Anchor, Image } from "grommet";
import { PropsWithChildren } from "react";
import { AppPage } from "../components/app-page";
import React from "react";
import Camp2 from "../images/camp2.png";

const Travel: React.FC<PropsWithChildren> = () => {
    return (
        <AppPage>
            <>

                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_foreground' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "medium" }} >
                        <Header direction="column" gap="small" overflow="hidden" className="title-medium" >
                            <Heading weight="normal" margin="none" textAlign="center" color="green_foreground">travel</Heading>
                        </Header>
                    </Box>
                </PageContent>


                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" pad={{ horizontal: "large", vertical: "large" }}>
                        <Heading className="small-text" weight="normal" size="50px" margin="none" color="green_foreground" textAlign="center">step 1: don't get sick</Heading>
                        <Paragraph color="green_foreground">
                            We do not want anyone to get sick at camp! Most spaces are very well-ventilated, but here are some extra things you can do to keep everyone safe:
                            <ul>
                                <li>Wear a well-fitting KN95 or N95 mask in airports, planes, trains, etc when travelling to the event</li>
                                <li>Wear a mask in any crowded areas or events in the week leading up to the wedding</li>
                                <li>Do not come if you are having any symptoms of illness.</li>
                            </ul>
                        </Paragraph>
                    </Box>
                </PageContent>

                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'orange' }}>
                    <Box align="center" pad={{ horizontal: "large", vertical: "large" }}>
                        <Heading className="small-text" weight="normal" size="50px" margin="none" color="charcoal" textAlign="center">step 2: get a park pass</Heading>
                        <Paragraph color="charcoal">
                            Each vehicle will need to purchase ($20) or show proof of a park pass to enter the park. You can buy a pass ahead of time online <Anchor href="https://www.nps.gov/prwi/planyourvisit/fees.htm">here</Anchor>. If you need to purchase a pass in person, please stop by the visitors center or the entrance station to the main park at
                        </Paragraph>
                        <Paragraph color="charcoal">
                            <Anchor href="https://maps.app.goo.gl/Lsmpc4aReF6XLLF28" target="_">18170 Park Entrance Rd, Triangle, VA 22172</Anchor>
                        </Paragraph>
                    </Box>
                </PageContent>

                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'cream' }}>
                    <Box align="center" pad={{ horizontal: "large", vertical: "large" }}>
                        <Heading className="small-text" weight="normal" size="50px" margin="none" color="green_foreground" textAlign="center">step 3: find camp</Heading>
                        <Paragraph color="charcoal">
                            <Anchor href="https://maps.app.goo.gl/kc9W2sQtVtz3m2JL7" target="_" color="cream"> 17175 Mawavi Rd, Triangle, VA 22172
                            </Anchor>
                        </Paragraph>
                        <Paragraph color="green_foreground">

                            <b>From Points North</b> Use Interstate 95 South. Take Virginia exit 150 onto Joplin Road, Highway 619. Continue on Joplin Road for four and a half miles. Turn right on Mawavi Road. Mawavi Road is gravelled. In one-eighth of a mile, the road comes to a T intersection. Turn left to Cabin Camp 2. Drive one mile to the parking lot.
                        </Paragraph>
                        <Paragraph color="green_foreground" >

                            <b>From Points South</b> Use Interstate 95 North. Take Virginia exit 150. At the stopsign at the bottom of the exit ramp, turn left. Continue on Joplin Road for five miles. Turn right on Mawavi Road. Mawavi Road is gravelled. In one-eighth of a mile, the road comes to a T intersection. Turn left to Cabin Camp 2. Drive one mile to the parking lot.
                        </Paragraph>

                        <Paragraph color="green_foreground" >


                            <b>From Points West</b> From the community of Independent Hill, use Joplin Road Highway 619 to approach the camp. Turn left at Mawavi Road. Mawavi Road is gravelled. In one-eighth of a mile, the road comes to a T intersection. Turn left to reach Cabin Camp 2. Drive one mile to the parking lot.
                        </Paragraph>
                        <Paragraph color="green_foreground">

                            For more information and maps, see <Anchor className="small-text" weight="normal" color="cream" href="https://www.nps.gov/prwi/planyourvisit/directions.htm" target="_">here</Anchor>.

                        </Paragraph>
                    </Box>
                </PageContent>

                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_foreground' }}>
                    <Box align="center" pad={{ horizontal: "large", vertical: "large" }}>
                        <Heading className="small-text" weight="normal" size="50px" margin="none" color="cream" textAlign="center">step 4: check-in</Heading>

                        <Paragraph color="cream" >
                            Once you make it to the parking lot, stop by the check-in cabin on the southeast side of the lot for a map and further instructions. Cell service is pretty spotty in the camp, so we will have a walkie talkie at the check-in cabin if you need to reach us. If you have trouble finding the camp, you can call the park visitor center at <b>(703) 221-7181</b>.
                        </Paragraph>
                        <Paragraph color="cream" >
                            The gravel roads around camp are gated from car traffic, so there will be several wagons available to help you get your things from the parking lot to your cabin. There is a small lot next to the dining hall where one vehicle can park temporarily for dropping off passengers or larger items.
                        </Paragraph>
                        <Paragraph color="cream" textAlign="center">

                            <Image src={Camp2} alt="Cabin Camp 2 Map" className="cabin-image" alignSelf="center" />
                        </Paragraph>

                    </Box>
                </PageContent>

            </>
        </AppPage>
    );
}

export default Travel;
